// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"f9b54c29","148":"4ecfd3df","210":"4918e3c8","220":"714d36ef","254":"d68568c0","336":"401bc613","473":"cd72856b","743":"2d8fd3f2","825":"3ccd4400","840":"5eb1b115"}[chunkId] + ".chunk.js";
};